export const SET_INSTRUCTIONS = 'SET_INSTRUCTIONS';
export const SET_INSTRUCTION = 'SET_INSTRUCTION';
export const ADD_INSTRUCTION = 'ADD_INSTRUCTION';
export const UPDATE_INSTRUCTION = 'UPDATE_INSTRUCTION';
export const REMOVE_INSTRUCTION = 'REMOVE_INSTRUCTION';
export const CLEAR_INSTRUCTION = 'CLEAR_INSTRUCTION';
export const CLEAR_INSTRUCTIONS = 'CLEAR_INSTRUCTIONS';
